import React from 'react';

import Kit from '../layout/Kit.jsx';
import Utilities from './Utilities.jsx';

const Token = {
    AlternateDimensions: 'ALTERNATE_DIMENSIONS',
    AlternatePrices: 'ALTERNATE_PRICES',
    ArtistCV: 'ARTIST_CV',
    ArtistBiography: 'ARTIST_BIOGRAPHY',
    ArtistLifespan: 'ARTIST_LIFESPAN',
    ArtistName: 'ARTIST_NAME',
    BlogPostLink: 'BLOG_POST_LINK',
    ButtonText: Kit.Button.token,
    CompanyName: 'COMPANY_NAME',
    ContactPageLink: 'CONTACT_PAGE_LINK',
    Count: 'COUNT',
    Date: 'DATE',
    Description: 'DESCRIPTION',
    Dimensions: 'DIMENSIONS',
    Discount: 'DISCOUNT',
    Edition: 'EDITION',
    EditionCount: 'EDITION_COUNT',
    ErrorMessage: 'ERROR_MESSAGE',
    Excerpt: 'EXCERPT',
    Framed: 'FRAMED',
    Framing: 'FRAMING',
    Group: 'GROUP',
    HeaderText: 'HEADER_TEXT',
    Hours: 'HOURS',
    InputText: 'INPUT_TEXT',
    InventoryNumber: 'INVENTORY_NUMBER',
    ItemTitle: 'ITEM_TITLE',
    Location: 'LOCATION',
    Medium: 'MEDIUM',
    Mounting: 'MOUNTING',
    Notes: 'NOTES',
    OpeningReception: 'OPENING_RECEPTION',
    ParagraphText: 'PARAGRAPH_TEXT',
    Phone: 'PHONE',
    PromoCode: 'PROMO_CODE',
    Price: 'PRICE',
    Quantity: 'QUANTITY',
    Published: 'PUBLISHED',
    SearchTerm: 'SEARCH_TERM',
    SKU: 'SKU',
    Sold: 'SOLD',
    StatusIndicator: 'STATUS_INDICATOR',
    TabTitle: 'TAB_TITLE',
    Title: 'TITLE',
    Unframed: 'UNFRAMED',
    Website: 'WEBSITE',

    Address: {
        City: 'CITY',
        Country: 'COUNTRY',
        Line1: 'ADDRESS_LINE1',
        Line2: 'ADDRESS_LINE2',
        State: 'STATE',
        Zip: 'ZIP'
    },

    Cart: {
        EstimatedShipping: 'ESTIMATED_SHIPPING',
        EstimatedTax: 'ESTIMATED_TAX',
        Subtotal: 'SUBTOTAL'
    },

    ExchangeCurrency: {
        Rate: [
            'AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN',
            'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BOV',
            'BRL', 'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHE', 'CHF',
            'CHW', 'CLF', 'CLP', 'CNY', 'COP', 'COU', 'CRC', 'CUP', 'CVE', 'CZK',
            'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'EUR', 'FJD', 'FKP',
            'GBP', 'GEL', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL',
            'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD',
            'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT',
            'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD',
            'MMK', 'MNT', 'MOP', 'MRU', 'MUR', 'MVR', 'MWK', 'MXN', 'MXV', 'MYR',
            'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN',
            'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF',
            'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SLE', 'SOS', 'SRD',
            'SSP', 'STN', 'SVC', 'SYP', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP',
            'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'USN', 'UYI', 'UYU',
            'UYW', 'UZS', 'VED', 'VES', 'VND', 'VUV', 'WST', 'XAF', 'XAG', 'XAU',
            'XBA', 'XBB', 'XBC', 'XBD', 'XCD', 'XDR', 'XOF', 'XPD', 'XPF', 'XPT',
            'XSU', 'XTS', 'XUA', 'XXX', 'YER', 'ZAR', 'ZMW', 'ZWG'
        ],

        value: (type) => Token.ExchangeCurrency.Rate.indexOf(type)
    },

    parsing: {
        artist: (data, keyword, options) => {
            let artist = data || {};
            if (artist.artist) {
                artist = artist.artist;
            }
            let replaceString = '';
            switch (keyword) {
                case Token.Address.Country:
                    if (artist.address && artist.address.country && artist.address.country.length > 0) {
                        replaceString = Token.getReplacementString(artist.address.country, options);
                    }
                    break;
                case Token.Address.State:
                    if (artist.address && artist.address.state && artist.address.state.length > 0) {
                        replaceString = Token.getReplacementString(artist.address.state, options);
                    }
                    break;
                case Token.ArtistBiography:
                    if (artist.bio && artist.bio.length > 0) {
                        replaceString = artist.bio;
                    } else if (artist.description && artist.description.length > 0) {
                        replaceString = artist.description;
                    }
                    if (replaceString) {
                        if (replaceString.startsWith('<p')) {
                            replaceString = Token.cleanTokenValueForReplacement(replaceString);
                        } else {
                            replaceString = replaceString.replaceAll('\n', '<br/>');
                        }
                        replaceString = Token.getReplacementString(replaceString, options);
                    }
                    break;
                case Token.ArtistCV:
                    if (artist.curriculumVitae && artist.curriculumVitae.length > 0) {
                        replaceString = artist.curriculumVitae;
                    }
                    if (replaceString.length > 0) {
                        if (replaceString.startsWith('<p')) {
                            replaceString = Token.cleanTokenValueForReplacement(replaceString);
                        } else {
                            replaceString = replaceString.replaceAll('\n', '<br/>');
                        }
                        replaceString = Token.getReplacementString(replaceString, options);
                    }
                    break;
                case Token.ArtistLifespan:
                    if (artist.lifespan && artist.lifespan.length > 0) {
                        replaceString = Token.getReplacementString(artist.lifespan, options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__artist__lifespan'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.ArtistName:
                    if (artist.name && artist.name.length > 0) {
                        replaceString = Token.getReplacementString(artist.name, options);

                        let className = 'notranslate';
                        if (data.wrapContent != false) {
                            className = `${data.contentClassNames && data.contentClassNames[keyword] || 'artwork__artist'} ${className}`;
                        }
                        replaceString = `<span class='${className}'>${replaceString}</span>`;
                    }
                    break;
                default:
                    replaceString = undefined;
                    break;
            }
            return replaceString;
        },

        blogContent: (data, keyword, options) => {
            const blog = data.blogContent || {};

            let replaceString = '';
            switch (keyword) {
                case Token.BlogPostLink:
                    if (options && options.display && options.display.length > 0 && data.link) {
                        replaceString = `<a href=${data.link} style='color: inherit;'>${options.display}</a>`;
                    }
                    break;
                case Token.Excerpt:
                    if (blog.excerpt && blog.excerpt.length > 0) {
                        replaceString = Token.getReplacementString(blog.excerpt, options);
                    }
                    break;
                case Token.Published:
                    if (blog.publishedAt && blog.publishedAt.length > 0) {
                        replaceString = Token.getReplacementString(blog.publishedAt, options);
                    } else {
                        const date = new Date();
                        replaceString = `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
                    }
                    break;
                case Token.Title:
                    if (blog.title && blog.title.length > 0) {
                        replaceString = Token.getReplacementString(blog.title, options);
                        if (data.link) {
                            replaceString = `<a href=${data.link} style='color: inherit;'>${replaceString}</a>`;
                        }
                    }
                    break;
                default:
                    replaceString = undefined;
                    break;
            }
            return replaceString;
        },

        inventory: (data, keyword, options) => {
            const edition = data.edition || {};
            const inventory = data.inventory || {};

            let replaceString = '';
            const temp = Token.ExchangeCurrency.value(keyword);
            if (temp >= 0) {
                if (edition.prices) {
                    for (let i = 0; i < edition.prices.length; i++) {
                        if (edition.prices[i].currency != temp) {
                            continue;
                        }
                        const value = edition.prices[i].value;
                        if (value && value.length > 0) {
                            replaceString = Token.getReplacementString(value, options);
                        }
                        break;
                    }
                }
                return replaceString;
            }
            switch (keyword) {
                case Token.AlternateDimensions:
                    if (edition.alternateDimensions && edition.alternateDimensions.length > 0) {
                        replaceString = Token.getReplacementString(edition.alternateDimensions, options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='${data.contentClassNames && data.contentClassNames[keyword] || 'artwork__info__item__altdims'}'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.ArtistLifespan:
                    if (inventory.artist && inventory.artist.lifespan && inventory.artist.lifespan.length > 0) {
                        replaceString = Token.getReplacementString(inventory.artist.lifespan, options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__artist__lifespan'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.ArtistName:
                    if (inventory.artist && inventory.artist.name && inventory.artist.name.length > 0) {
                        replaceString = Token.getReplacementString(inventory.artist.name, options);

                        let className = 'notranslate';
                        if (data.wrapContent != false) {
                            className = `artwork__artist ${className}`;
                        }
                        replaceString = `<span class='${className}'>${replaceString}</span>`;
                    }
                    break;
                case Token.Date:
                    if (inventory.date && inventory.date.length > 0) {
                        replaceString = Token.getReplacementString(inventory.date, options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__info__item__date'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.Dimensions:
                    if (edition.dimensions && edition.dimensions.display && edition.dimensions.display.formatted && edition.dimensions.display.formatted.length > 0) {
                        replaceString = Token.getReplacementString(edition.dimensions.display.formatted, options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__info__item__dimensions'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.Edition:
                    if (edition.edition && edition.edition.length > 0) {
                        replaceString = Token.getReplacementString(edition.edition, options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__info__item__edition'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.Framed:
                    if (edition.isFramed && options && options.display && options.display.length > 0) {
                        replaceString = options.display;
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__info__item__framed'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.Framing:
                    if (edition.framing && edition.framing.length > 0) {
                        replaceString = Token.getReplacementString(edition.framing, options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__info__item__framing__dimensions'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.InventoryNumber:
                    if (inventory.number != null && (inventory.number + '').length > 0) {
                        replaceString = Token.getReplacementString(inventory.number, options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__info__item__number'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.Location:
                    if (inventory.location && inventory.location.length > 0) {
                        replaceString = Token.getReplacementString(inventory.location, options);
                    }
                    break;
                case Token.Medium:
                    if (inventory.medium && inventory.medium.length > 0) {
                        replaceString = Token.getReplacementString(inventory.medium, options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__info__item__medium'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.Mounting:
                    if (edition.mounting && edition.mounting.length > 0) {
                        replaceString = Token.getReplacementString(edition.mounting, options);
                    }
                    break;
                case Token.Notes:
                    if (inventory.notes && inventory.notes.length > 0) {
                        replaceString = Token.getReplacementString(Token.cleanTokenValueForReplacement(inventory.notes), options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__notes'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.Price:
                    if (edition.price && edition.price.length > 0) {
                        if (options && options.showIfSold == 'false' && edition.isSold) {
                            break;
                        }
                        replaceString = Token.getReplacementString(edition.price, options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__info__item__price'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.Quantity:
                    if (inventory.quantity) {
                        replaceString = Token.getReplacementString(inventory.quantity, options);
                    }
                    break;
                case Token.SKU:
                    if (inventory.sku && inventory.sku.length > 0) {
                        replaceString = Token.getReplacementString(inventory.sku, options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__info__item__sku'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.Sold:
                    if (edition.isSold && options && options.display && options.display.length > 0) {
                        replaceString = options.display;
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__info__item__sold'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.StatusIndicator: {
                    let className, colorKey;
                    if (edition.isSold) {
                        className = 'artwork__sold-sticker';
                        colorKey = 'colorSold';
                    } else if (edition.isOnHold) {
                        className = 'artwork__hold-sticker';
                        colorKey = 'colorHold';
                    } else if (!edition.active) {
                        className = 'artwork__inactive-sticker';
                        colorKey = 'colorInactive';
                    }
                    if (colorKey) {
                        const style = [];
                        if (options) {
                            if (options[colorKey]) {
                                style.push(`background-color:${options[colorKey]}`);
                            }
                            if (options.size) {
                                style.push(`height:${options.size}`);
                                style.push(`width:${options.size}`);
                            }
                        }
                        replaceString = `<span class='${className}' style='${style.join(';')}'></span>`;
                    }
                    break;
                }
                case Token.Title:
                    if (inventory.title && inventory.title.length > 0) {
                        replaceString = Token.getReplacementString(inventory.title, options);

                        let className = 'notranslate';
                        if (data.wrapContent != false) {
                            className = `artwork__title ${className}`;
                        }
                        replaceString = `<span class='${className}'>${replaceString}</span>`;
                    }
                    break;
                case Token.Unframed:
                    if (!edition.isFramed && options && options.display && options.display.length > 0) {
                        replaceString = options.display;
                        if (data.wrapContent != false) {
                            replaceString = `<span class='artwork__info__item__unframed'>${replaceString}</span>`;
                        }
                    }
                    break;
                default:
                    replaceString = undefined;
                    break;
            }
            return replaceString;
        },

        pages: (data, keyword, options) => {
            let page = data || {};
            if (page.pages) {
                page = page.pages;
            }
            let replaceString = '';
            switch (keyword) {
                case Token.Title:
                    if (page.title && page.title.length > 0) {
                        replaceString = Token.getReplacementString(page.title, options);
                    }
                    break;
                default:
                    replaceString = undefined;
                    break;
            }
            return replaceString;
        },

        show: (data, keyword, options) => {
            const show = data.show || {};

            let replaceString = '';
            switch (keyword) {
                case Token.Date:
                    if (show.date && show.date.length > 0) {
                        replaceString = Token.getReplacementString(show.date, options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='show__card__date'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.Description:
                    if (show.about && show.about.length > 0) {
                        replaceString = Token.getReplacementString(Token.cleanTokenValueForReplacement(show.about), options);
                        if (data.wrapContent != false) {
                            replaceString = `<span class='description'>${replaceString}</span>`;
                        }
                    }
                    break;
                case Token.OpeningReception:
                    if (show.openingReception && show.openingReception.length > 0) {
                        replaceString = Token.getReplacementString(Token.cleanTokenValueForReplacement(show.openingReception), options);
                    }
                    break;
                case Token.Title:
                    if (show.title && show.title.length > 0) {
                        replaceString = Token.getReplacementString(show.title, options);
                        if (data.wrapContent != false) {
                            let className = 'notranslate';
                            if (data.wrapContent != false) {
                                className = `${data.contentClassNames && data.contentClassNames[keyword] || 'show__card__title'} ${className}`;
                            }
                            replaceString = `<span class='${className}'>${replaceString}</span>`;
                        }
                    }
                    break;
                default:
                    replaceString = undefined;
                    break;
            }
            return replaceString;
        }
    },

    cleanTokenValueForReplacement: (tokenValue) => {
        let cleanToken = tokenValue
            .replaceAll('\n', '')
            .replaceAll('<div style="', '<span style="display: block;')
            .replaceAll('<div', '<span style="display: block;"')
            .replaceAll('</div>', '</span>');
        const headingTypes = [
            Kit.Context.Global.Paragraph,
            Kit.Context.Global.Header1,
            Kit.Context.Global.Header2,
            Kit.Context.Global.Header3,
            Kit.Context.Global.Header4,
            Kit.Context.Global.Header5,
            Kit.Context.Global.Header6
        ];
        headingTypes.forEach((d) => {
            cleanToken = cleanToken
                .replaceAll(`<${d} style="`, '<span style="display: block;')
                .replaceAll(`<${d}`, '<span style="display: block;"')
                .replaceAll(`</${d}>`, '</span>')
        });
        return cleanToken;
    },

    convertTokenContainers: (design, conversionMap) => {
        if (!conversionMap || !design || design.indexOf('<p') < 0) {
            return design;
        }
        const lines = design.split('</p>');
        let _design = '';

        const searchString = 'token="';
        let endIndex, startIndex, tag, token;
        lines.forEach((d) => {
            startIndex = d.indexOf(searchString);
            while (startIndex >= 0) {
                startIndex += searchString.length;
                endIndex = d.indexOf('"', startIndex);
                if (endIndex < 0) {
                    // Something went wrong
                    break;
                } else {
                    token = d.substring(startIndex, endIndex);
                    tag = conversionMap[token];
                    if (tag) {
                        // Found conversion for token => Convert entire line and stop processing
                        _design += `${d.replace('<p', `<${tag}`)}</${tag}>`
                        return;
                    }
                }
                // Find next token
                startIndex = d.indexOf(searchString, endIndex);
            }
            if (d) {
                // No conversion found => Leave line as is
                _design += `${d}</p>`;
            }
        });
        return _design;
    },

    getReplacementString: (value, options) => {
        let replaceString = '';
        if (value && value.toString().length > 0) {
            if (options && options.before) {
                replaceString += options.before;
            }
            replaceString += value;
            if (options && options.after) {
                replaceString += options.after;
            }
        }
        return replaceString;
    },

    parseTokenizedString: function (tokenizedString, handler) {
        let parsedResultString = tokenizedString;
        let char, options;
        let indexStart = parsedResultString.indexOf('{');
        let indexEnd = indexStart;
        let keyword = '';
        let parsingList = false;
        let parsingOptions = false;
        let parsingString = false;
        while (indexStart >= 0 && indexEnd < parsedResultString.length - 1) {
            indexEnd += 1;
            char = parsedResultString.charAt(indexEnd);
            switch (char) {
                case '(':
                    if (parsingList || parsingOptions || parsingString) {
                        options += char;
                        break;
                    }
                    // Start options
                    options = '';
                    parsingOptions = true;
                    break;
                case ')':
                    if (parsingList || parsingString) {
                        options += char;
                        break;
                    }
                    // End options
                    parsingOptions = false;
                    break;
                case '[':
                    if (parsingOptions) {
                        parsingList = true;

                        // List components are converted to strings (wrapped in quotes) since they will be parsed separately
                        options += char;
                    }
                    break;
                case '"':
                    if (parsingList || parsingOptions) {
                        options += '"';
                        parsingString = !parsingString;
                    }
                    break;
                case ']':
                    if (parsingOptions) {
                        // List components are converted to strings (wrapped in quotes) since they will be parsed separately
                        options += char;
                    }
                    parsingList = false;
                    break;
                case '}':
                    if (parsingOptions) {
                        options += char;
                        break;
                    }
                    // End keyword
                    let parsedProps;
                    if (options) {
                        try { parsedProps = JSON.parse(`{${options}}`); } catch (e) { }
                    }
                    let replaceString;
                    switch (keyword) {
                        case Token.AlternatePrices:
                        case Token.Group:
                            if (!parsedProps) {
                                break;
                            }
                            let parsedComponents = [];
                            if (parsedProps.components && parsedProps.components.length > 0) {
                                // Get replacement strings for each component in the group
                                parsedProps.components.forEach((d) => {
                                    if (!d) {
                                        return;
                                    }
                                    const string = d.replaceAll('"', '\\\"').replaceAll("*'", '"').trim();
                                    const parsedComponent = Token.parseTokenizedString(string, handler);
                                    if (parsedComponent === "") {
                                        return;
                                    }
                                    if (parsedComponent != undefined) {
                                        parsedComponents.push(parsedComponent);
                                    } else {
                                        parsedComponents.push(d);
                                    }
                                })
                            }
                            replaceString = Token.getReplacementString(parsedComponents.join(parsedProps.separator ? parsedProps.separator : ''), parsedProps);
                            break;
                        default:
                            if (handler) {
                                // Get the replacement string for the token keyword and props
                                replaceString = handler(keyword, parsedProps);
                            }
                    }
                    if (replaceString != undefined) {
                        // Replace the token with the replacement string
                        parsedResultString = parsedResultString.substring(0, indexStart) + replaceString + parsedResultString.substring(indexEnd + 1);

                        // Update end index to point to the end of the replacement string so parts of the string aren't skipped or processed twice
                        indexEnd = indexStart + replaceString.length;
                    }
                    keyword = '';
                    options = undefined;

                    // Find start of next keyword (if present)
                    indexStart = parsedResultString.indexOf('{', indexEnd);
                    indexEnd = indexStart;
                    break;
                default:
                    if (parsingOptions) {
                        options += char;
                    } else {
                        keyword += char;
                    }
                    break;
            }
        }
        return parsedResultString;
    },

    // TOKEN CONFIG

    getAlternatePricesTokenConfig: () => {
        return {
            display: 'Alternate Prices',
            options: Token.ExchangeCurrency.Rate.map(d => Token.getAlternatePriceTokenConfig(d)),
            token: Token.AlternatePrices
        }
    },

    getAlternatePriceTokenConfig: (value) => {
        return { ...Token.getWrappedTokenConfig(value, value), includeInTokenMap: true, name: value }
    },

    getPriceTokenConfig: () => {
        const priceToken = Token.getWrappedTokenConfig('Price', Token.Price);
        priceToken.options.splice(0, 0, { defaultValue: 'true', label: 'Show if sold?', name: 'showIfSold', type: 'toggle', value: 'true' });
        return priceToken;
    },

    getStatusIndicatorTokenConfig: (token) => {
        return {
            display: 'Status Indicator',
            isObject: true,
            options: [
                { display: 'Sold Color', name: 'colorSold', type: 'color' },
                { display: 'Inactive Color', name: 'colorInactive', type: 'color' },
                { display: 'On Hold Color', name: 'colorHold', type: 'color' },
                { display: 'Size', name: 'size', type: 'measurement' }
            ],
            token
        }
    },

    getWrappedTokenConfig: (display, token) => {
        return {
            display,
            format: (data) => { return `${data.before || ''}{${data.token}}${data.after || ''}` },
            options: [
                { display: 'Prefix Label', name: 'before' },
                { display: 'Suffix Label', name: 'after' }
            ],
            token
        };
    },

    // HOC

    withContentTokenParsing: (WrappedComponent, { allowEmptyContent, contentTokenSourceHandler, extraParseConditionHandler, headerConversionMap }, tokenHandler) => {
        return function (props) {
            const [id, setId] = React.useState(undefined);
            React.useEffect(() => { setId(Utilities.generateUniqueId()) }, []);

            const parseContent = function (props, tokenizedString) {
                if (!tokenizedString || !id) {
                    return '';
                }
                let design = Token.convertTokenContainers(tokenizedString, headerConversionMap);
                design = Token.parseTokenizedString(design, (keyword, options) => tokenHandler ? tokenHandler(props, keyword, options) : '');
                if (Utilities.isHTMLContentEmpty(design)) {
                    return '';
                }
                return design;
            }
            const [content, setContent] = React.useState(undefined);
            const updateContent = (props, tokenizedString) => {
                if (!id) {
                    return;
                }
                setContent(parseContent(props, tokenizedString))
            }
            const parseConditions = [id, props.blockConfig.block.design];
            if (extraParseConditionHandler) {
                parseConditions.push(...extraParseConditionHandler(props));
            }
            React.useEffect(() => updateContent(props, contentTokenSourceHandler ? contentTokenSourceHandler(props) : props.blockConfig.block.design), parseConditions);

            if (allowEmptyContent != true && !props.builder && content != undefined && content.length == 0) {
                return null;
            }
            return <WrappedComponent {...props} content={content} onParseContent={parseContent} onUpdateContent={updateContent}>{props.children}</WrappedComponent>
        }
    }
};
export default Token;